import { Error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchBestSellingProductsAPI() {
    const response = await fetch(`${baseURL}/api/version3/products/best-selling`);
    if(!response.ok) throw new Error("Failed to retch best selling products data");
    return response.json()
}